import classNames from 'classnames'
import React, { useEffect } from 'react'

export interface EsisTagProps {
    context: string
    content: string
    language: string
    customerUuid: string
    className?: string
    url?: string
}

export const EsisTag = (props: EsisTagProps) => {
    const className = classNames('esis-tag', props.className)
    const url = props.url || process.env.APP_ESIS_TAG_WIDGET_URL! || 'https://content.snouts.io/widget.js'

    useEffect(() => {
        let script: HTMLScriptElement | null = document.querySelector(`script[src="${url}"]`)

        if (!script) {
            script = document.createElement('script')
            script.type = 'application/javascript'
            script.src = url
            script.async = true
            script.type = 'module'
            document.body.appendChild(script)
        }
    }, [url])

    return (
        <div className={className}>
            <s-frame
                data-context={props.context}
                data-content={props.content}
                data-language={props.language}
                data-custom={props.customerUuid}
            ></s-frame>
        </div>
    )
}
